import React, { useState } from "react";

import { DropdownProfile } from "../components/DropdownProfile";
import ThemeToggle from "../components/ThemeToggle";
import { CreateTaskModal } from "components/templates/CreateTaskModal/CreateTaskModal";
import { useLocation, matchPath } from "react-router-dom";
import { TaskResource, TaskResourceType } from "components/templates/CreateTaskModal/TaskForm";
import { routes } from "consts";
import { DropdownNotifications } from "./DropdownNotifications";

interface HeaderProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}
type Rule = {
  route: string;
  type: TaskResourceType;
  paramName: string;
};
const rules: Rule[] = [
  { route: routes.COURSES_MANAGE(), type: "course", paramName: "courseId" },
  { route: routes.COURSES_EDIT(), type: "course", paramName: "courseId" },
  { route: routes.STUDENT(), type: "student", paramName: "studentId" },
  { route: routes.STUDENT_EDIT(), type: "student", paramName: "studentId" },
  { route: routes.TRAINERS_EDIT(), type: "trainer", paramName: "trainerId" },
  { route: routes.TRAINER(), type: "trainer", paramName: "trainerId" },
  { route: routes.TOPICS_EDIT(), type: "topic", paramName: "topicId" },
  { route: routes.TOPICS_GROUPS_EDIT(), type: "topicGroup", paramName: "topicGroupId" },
  { route: routes.PLACES_EDIT(), type: "place", paramName: "placeId" },
  { route: routes.DISCOUNTS_EDIT(), type: "payment-discount", paramName: "discountId" },
  { route: routes.DICTIONARIES_EDIT(), type: "dictionary", paramName: "dictionaryId" },
  { route: routes.DOCUMENT_TYPES_EDIT(), type: "document-type", paramName: "documentTypeId" },
  { route: routes.EMAILS_TRIGGERS_EDIT(), type: "email-template", paramName: "emailTemplateId" },
  { route: routes.SURVEYS_PAGES(), type: "survey", paramName: "surveyId" },
  { route: routes.EXAMS_EDIT(), type: "exam", paramName: "examId" },
];

const Header = ({ sidebarOpen, setSidebarOpen }: HeaderProps) => {
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [resource, setResource] = useState<TaskResource | null>(null);
  const location = useLocation();

  const onAddTask = () => {
    const matchingRule = rules.find((rule) => matchPath(rule.route, location.pathname));
    if (!!matchingRule) {
      const pathData = matchPath(matchingRule.route, location.pathname);
      const id = pathData?.params[matchingRule.paramName];
      const currentRoute = location.pathname;
      setResource({
        type: matchingRule.type,
        link: currentRoute,
        id: Number(id),
      });
    } else {
      setResource({ type: "general" });
    }
  };
  return (
    <header className="sticky top-0 z-30 border-b border-slate-200 bg-white dark:border-slate-700 dark:bg-[#182235]">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="-mb-px flex h-16 items-center justify-between">
          {/* Header: Left side */}
          <div className="flex">
            {/* Hamburger button */}
            <button
              className="text-slate-500 hover:text-slate-600 lg:hidden"
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              onClick={(e) => {
                e.stopPropagation();
                setSidebarOpen(!sidebarOpen);
              }}
            >
              <span className="sr-only">Open sidebar</span>
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="2" />
                <rect x="4" y="11" width="16" height="2" />
                <rect x="4" y="17" width="16" height="2" />
              </svg>
            </button>
          </div>

          {/* Header: Right side */}
          <div className="flex items-center space-x-3">
            <div>
              <button
                className={`ml-3 flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600/80 ${
                  searchModalOpen && "bg-slate-200"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  setSearchModalOpen(true);
                  onAddTask();
                }}
              >
                <svg className="h-4 w-4 fill-current text-slate-500 dark:text-slate-400" viewBox="0 0 16 16">
                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1Z" />
                </svg>
              </button>
              <CreateTaskModal resource={resource} onCloseRequest={() => setResource(null)} />
              {/* <SearchModal
                id="search-modal"
                searchId="search"
                modalOpen={searchModalOpen}
                setModalOpen={setSearchModalOpen}
              /> */}
            </div>
            <DropdownNotifications align="right" />
            <ThemeToggle />
            <hr className="h-6 w-px border-none bg-slate-200 dark:bg-slate-700" />
            <DropdownProfile align="right" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
